import { render, staticRenderFns } from "./newQuestionnaire.vue?vue&type=template&id=134132ca&scoped=true&"
import script from "./newQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./newQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./newQuestionnaire.vue?vue&type=style&index=0&id=134132ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134132ca",
  null
  
)

export default component.exports